import { Button } from "@plum-xoxo/admin-dsm";
import Typography from "@plum-xoxo/admin-dsm/core/typography/Typography";
import React from "react";
import styled from "styled-components";
import EditMask from "./EditMask";

const StyledDiv = styled.div`
  border: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;
const DividerDiv = styled.div`
  padding: 16px 0 0;
  border-top: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;

const BorderDiv = styled.div`
  border-top: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;

const RewardDiv = styled.div`
  width: 60%;
  padding: 12px 20px;
  border-right: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;

const PointsDiv = styled.div`
  width: 60%;
  padding: 20px;
  border-right: 1px solid;
  border-color: ${(props) => props.theme.palette.light.c300};
`;

const ExpiryDiv = styled.div`
  width: 40%;
  padding: 14px 32px;
`;
const ValidityDiv = styled.div`
  width: 40%;
  padding: 20px 32px;
`;

const XoxoPointRewardBody = ({
  validTill,
  isDesktopPreview,
  platformSetting,
  toggleTextModal,
  buttonText,
}) => {
  return (
    <div className="text-center">
      <Typography.DisplayText color="dark" shade="c300">
        ****
      </Typography.DisplayText>
      <Typography.BodySmall className="mt-20 mb-8" color="dark" shade="c200">
        {platformSetting?.customText?.empulsPoints || "Xoxo Reward Points"}{" "}
        worth
      </Typography.BodySmall>

      <div className="position-relative my-16">
        <Button size="large" className="w-100 ">
            {buttonText}
        </Button>
        <EditMask
          buttonText="Button Text"
          top={0}
          toggleModalState={() => toggleTextModal()}
        />
      </div>
      <Typography.BodySmall color="dark" shade="c200">
        Expires on {validTill}
      </Typography.BodySmall>
    </div>
  );
};

export default XoxoPointRewardBody;
